import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import './design-guidelines-styles.css';
export const _frontmatter = {
  "pageTitle": "Toggle Design Guidelines",
  "title": "Toggle",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PageContent componentName="toggle" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  Toggle switches toggle the state of a single setting on or off.
      </LeadParagraph>
      <h2>{`Usage`}</h2>
      <p>{`Toggle switches are a great way to adjust settings when you are simply turning something on and off. The option that the switch controls, as well as the state it is in, should be made clear from the corresponding inline label.`}</p>
      <figure>{`
  `}<div parentName="figure" {...{
          "className": "image-container"
        }}>{`
    `}<span parentName="div" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "592px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "48.64864864864865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABVElEQVQoz5WSzW6CQBSFeZQ+le/RZZ+h+76B7rvovm660DZpEy0qIEIKyp+kRn6EGU5zrxmkjU3tJHDJZeZwPu7RmqbBpeuSvRrddrsdoihCGIaI4xjb7RZBECBJEvi+j81mAyllK6qEqQopIBvZ9liQDluWBcMwYNs2HMfBbDaD67qYTCaYTqeo6/qby3Nuqaf9B/knepp/YuS+wYwd5FV5ckio5Gi1WmG9XrOz5XKJxWLByOSansl5mqZocBS8ebiFdn2F/ss97OSD0VmQcA6HA4qi4JrnOcqy5Kp6WZbxVVVVK/gemLh76uM10JHVBajNgkIIFqBFP18NQOHRB2lPt0eSshKI/RDDxyF8zzsh04QJmTA9z4Ou64zXRTdNE/P5nB2qFUYhRs9j9Ho99AeDo2B3auSMoyBE67QbF/VenSFxihQlZL/fnxz+NenfInIuNl8Es/8v5iQP2gAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "",
              "title": "",
              "src": "/version/4.10.1/static/1383d03696be21b68f2792893017a81f/1b853/Toggle-switch-example.png",
              "srcSet": ["/version/4.10.1/static/1383d03696be21b68f2792893017a81f/a2ead/Toggle-switch-example.png 259w", "/version/4.10.1/static/1383d03696be21b68f2792893017a81f/6b9fd/Toggle-switch-example.png 518w", "/version/4.10.1/static/1383d03696be21b68f2792893017a81f/1b853/Toggle-switch-example.png 592w"],
              "sizes": "(max-width: 592px) 100vw, 592px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>{`
  `}</div>{`
  `}<figcaption parentName="figure">{`
    `}<p parentName="figcaption">{`Toggle switches`}</p>{`
  `}</figcaption>
      </figure>
      <h2>{`States`}</h2>
      <p>{`Toggles can be on, off, or disabled.`}</p>
      <figure>{`
  `}<div parentName="figure" {...{
          "className": "image-container"
        }}>{`
    `}<span parentName="div" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "592px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "62.16216216216216%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABfUlEQVQoz51SW07CQBRlCW7FzbgHflyBKzH65ZcL8Efil4kfSNAmRMOjFFootDzKo1ChnR5zbp0SIhpxkumdOzP3zDn3tJCmKY4dv9UU+Fmv17BtG51OB77vYzAYSN7r9TAcDiV2u12Jm80mB1VKIU5iqFTljwhgFEVS0Gw2pYhgzBn7/b6s2+22TA1IkEPMC3pxjHT1dddw33H7coeGbyHafuwYbrdb1Ot1OI4js1wuo1qtilzKJ8PlcpmzSFTG7uzmHCcXp3g0n+EEbgZ4iBllJUnyzQC91tEOXDw0ntAPPaTZQcaQADSD5qxWK5nz+VxyngVBsMdQZCuFKFzj7bWG68srOLazk8xDGuC6rkisVCqo1WoYjUbyECXPZrMcSDs8mUxwXyqhWCzCMIyfJf91xHEsD9GDPZcpq9VqwfM8McI0TcnH47FMsrcsK49sgTaTLKmGLcolE5kbi8UCYRhKEf9Hrtk7siDwdDqVyN5qQO7xvt77t+RDdZT8CT69l/wKXLc1AAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "",
              "title": "",
              "src": "/version/4.10.1/static/80b0c98716ad63d22310a74bb575a5e2/1b853/Toggle-switch-states.png",
              "srcSet": ["/version/4.10.1/static/80b0c98716ad63d22310a74bb575a5e2/a2ead/Toggle-switch-states.png 259w", "/version/4.10.1/static/80b0c98716ad63d22310a74bb575a5e2/6b9fd/Toggle-switch-states.png 518w", "/version/4.10.1/static/80b0c98716ad63d22310a74bb575a5e2/1b853/Toggle-switch-states.png 592w"],
              "sizes": "(max-width: 592px) 100vw, 592px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>{`
  `}</div>{`
  `}<figcaption parentName="figure">{`
    `}<p parentName="figcaption">{`Toggle switch states`}</p>{`
  `}</figcaption>
      </figure>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      